export default {
  'auth.email.suggestion': 'Meintest du {email}?',
  'auth.email.typoError': 'Bitte prüfe deine E-Mail-Adresse.',
  'auth.email.disposableError':
    'Bitte verwende eine dauerhafte E-Mail-Adresse. Wegwerf-Adressen können wir leider nicht annehmen.',
  'auth:common:label-email': 'E-Mail',
  'auth:common:label-email:focus': 'Deine E-Mail Adresse',
  'auth:common:label-password': 'Passwort',
  'auth:common:label-new-password': 'Neues Passwort',
  'auth:common:label-repeat-new-password': 'Neues Passwort wiederholen',
  'auth:common:button:to-login': 'Zum Login',

  'auth:activate-account:header': 'Account aktivieren',
  'auth:activate-account:sub-header': 'Bitte vergib ein Passwort für deinen Account',
  'auth:activate-account:account-activated': 'Dein Account wurde aktiviert.',
  'auth:activate-account:button:activate': 'Account aktivieren',
  'auth:activate-account:error-message':
    'Es ist ein fehler aufgetreten. Probiere es später noch einmal!',

  'auth:login:header': 'Anmelden',
  'auth:login:header:otp': 'Login mit Einmalcode',
  'auth:login:sheet:header': 'Willkommen bei Pets Deli',
  'auth:login:label:password': 'Passwort',
  'auth:login:button:login': 'Anmelden',
  'auth:login:button:recover-password': 'Kennwort vergessen?',
  'auth:login:link:create-new-account': 'Jetzt erstellen',
  'auth:login:question:dont-you-have-an-account': 'Noch kein Konto?',

  'auth:signup:label:password': 'Passwort',
  'auth:signup:label:confirmPassword': 'Passwort bestätigen',
  'auth:signup:label:submitButton': 'Weiter',
  'auth:signup:header-title:register': 'Registrieren',
  'auth:signup:link:log-in': 'Anmelden',
  'auth:signup:question:do-you-have-an-account': 'Hast du bereits ein Konto?',
  'auth:signup:hint:min-length-12': 'Das Passwort muss mindestens 12 Zeichen lang sein.',
  'auth:signup:header': 'Registrieren',
  'auth:signup:success-message': 'Konto erstellt',
  'auth:signup:show-password': 'Passwort anzeigen',
  'auth:signup:hide-password': 'Passwort verbergen',
  'auth:signup:ambassador-info':
    'Um deine Anmeldung als Pets Deli Ambassador abzuschließen, erstelle bitte zuerst ein Kundenkonto. Anschließend führen wir dich durch die weiteren Schritte.',

  'auth:recover-password:header': 'Passwort vergessen',
  'auth:recover-password:sub-header':
    'Falls ein Konto mit dieser E-Mail existiert, haben wir dir einen Link zum Zurücksetzen deines Passworts gesendet.',
  'auth:recover-password:button:reset-confirm': 'Passwort Zurücksetzen',
  'auth:recover-password:button:back-to-login': ' Zurück zum Login',

  'auth:reset-password:header': 'Neues Passwort vergeben',
  'auth:reset-password:button:change': 'Passwort verändern',
  'auth:reset-password:confirm': 'Dein Passwort wurde erfolgreich geändert.',
  'auth:reset-password:button:continue-purchase': 'Einkauf fortsetzen',

  'auth.login-warning.country-de': 'Deutschland',
  'auth.login-warning.country-ch': 'die Schweiz',
  'auth.login-warning.country-nl': 'die Niederlande',

  // Login Warning Messages, `country` is the country of the shop the account belongs to
  'auth:login-warning:title': 'Oh nein! 🐾 Dein Konto gehört zum Shop für {country}.',
  'auth:login-warning:message':
    'Bitte beachte: Dein Kundenkonto für {country} kann in diesem Shop leider nicht verwendet werden.',
  'auth:login-warning:link': "👉 Hier geht's zum Shop für {country}",
  'auth:login-warning:footer': 'Danke für dein Verständnis und bis bald im passenden Shop! 💚',
};
